<div class="wrapper">
    @if (!isEnabled) {
        <div class="overlay" [title]="overlayTooltip"></div>
    }
    <div class="container">
        <ng-container *ngTemplateOutlet="body"></ng-container>
    </div>
</div>
